import Vue from "vue"
import Vuex from "vuex"
import members from "./modules/members"
import soundsys from "./modules/soundsys"
import ui from "./modules/ui"

Vue.use(Vuex)
export const strict = false
export const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  modules: {
    soundsys,
    members,
    ui
  }
})
